import { Card, Typography } from '@material-ui/core';
import React from 'react';
import { connect } from 'react-redux';
import { IRiver } from '../../../@types/model/river/river';
import { IRootState } from '../../../@types/redux';
import { Transitions } from '../../customComponents/animations/Transitions';
import EditRiverDivisionInfo from '../dialog/EditDivisionInfo';

interface IRiverDivisionInfoViewProps {
    river : IRiver;

    isLoading : boolean;

    isRiverAdmin : boolean;
}

interface IRiverDivisionInfoViewState {}

class RiverDivisionInfoViewComponent extends React.PureComponent<IRiverDivisionInfoViewProps, IRiverDivisionInfoViewState> {
    constructor(props : IRiverDivisionInfoViewProps) {
        super(props);
        this.state = {};
    }

    public readonly render = () => {
        const { isRiverAdmin, river, isLoading } = this.props;

        return (
            <div className={'flx1 fdr aifs jcc mt15'}>
                <Card className={'bcw mt30 fdc'}>
                    <div className={'fdr flx1 dvbdg cw mb10 p10'}>
                        <Typography className={'fdr aic jcc flx1 fw600 fs16'}>
                            DIVISION INFORMATION
                        </Typography>
                        <div className='posr posr aic jcc'>
                            <div className='posa posr0'>
                                {
                                    isRiverAdmin &&
                                    <EditRiverDivisionInfo
                                        river={river}
                                        isLoading={isLoading}
                                        fullWidth
                                        maxWidth='md'
                                        transition={Transitions.Down}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                    <div className={'fdc flx1 ml17 mr17 mb13'}>
                        <div className={'flx1 mt9 fdr'}>
                            <div className={'bcg0 fdc flx1 aic jcc mr8 w200 p10'}>
                                <Typography className={'fs11 cdg'}>
                                    DIVISION
                                </Typography>
                                <Typography className={'fs13 cg3 fw700 pt10'}>
                                    {river.Division ? river.Division : 'None'}
                                </Typography>
                            </div>
                            <div className={'bcg0 fdc flx1 aic jcc mr8 w200 p10'}>
                                <Typography className={'fs11 cdg'}>
                                    MANAGMENT AREA
                                </Typography>
                                <Typography className={'fs13 cg3 fw700 pt10'}>
                                    {river.ManagementArea ? river.ManagementArea : 'None'}
                                </Typography>
                            </div>
                            <div className={'bcg0 fdc flx1 aic jcc mr8 w200 p10'}>
                                <Typography className={'fs11 cdg'}>
                                    DIVISION NUMBER
                                </Typography>
                                <Typography className={'fs13 cg3 fw700 pt10'}>
                                    {river.DivisionNumber ? river.DivisionNumber : 'None'}
                                </Typography>
                            </div>
                            <div className={'bcg0 fdc flx1 aic jcc mr8 w200 p10'}>
                                <Typography className={'fs11 cdg'}>
                                    ACCPAC DESCRIPTION
                                </Typography>
                                <Typography className={'fs13 cg3 fw700 pt10'}>
                                    {river.DivisionDescriptionAccpac ? river.DivisionDescriptionAccpac : 'None'}
                                </Typography>
                            </div>
                        </div>
                    </div>
                </Card>
            </div>
        );
    };
}

const mapStateToProps = (state : IRootState) => {
    return {
        isRiverAdmin: !!state.auth.session?.employee.IsRiverAdmin,
        isLoading: state.river.loading,
    };
};

const RiverDivisionInfoView = connect(
    mapStateToProps,
)(RiverDivisionInfoViewComponent);

export default RiverDivisionInfoView;
